import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IDictionaryRequirementSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryRequirementSelectOption';

export const NEW_REQUIREMENT_SELECT_OPTION_CODE = 'new';

export const newRequirementSelectOption: IDictionaryRequirementSelectOption = {
  id: 123,
  code: NEW_REQUIREMENT_SELECT_OPTION_CODE,
  title: null,
  nameNpa: null,
  numberNpa: null,
  label: 'Создать новый',
  value: {
    dictId: DictionaryUUIDsEnum.REQUIREMENT,
    dictVersionId: '',
  },
};
